import { t } from "../../../services/utils";
import React from "react";
import { primaryDark60 } from "../../../constants/colors";
import { calculateTextHeight } from "../../../services/utils";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
class RecordView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        backgroundColor: "white",
        display: "flex",
      },
      record: {
        fontFamily: "courier, courier new, serif",
        fontSize: 16,
        paddingLeft: 30,
        paddingRight: 10,
        paddingTop: this.props.paddingTop ? this.props.paddingTop : 0,
        paddingBottom: this.props.paddingBottom ? this.props.paddingBottom : 0,
        flex: "1 1 auto",
        color: primaryDark60,
      },
    };
    let record = this.props.record;
    return (
      <div style={styles.container}>
        <div style={styles.record}>{record}</div>
      </div>
    );
  };
  static getHeight(props) {
    let height = calculateTextHeight(props.record, STORY_VIEW_WIDTH - 40, {
      font: "courier, courier new, serif",
      fontSize: 16,
    });
    if (props.paddingTop) {
      height += props.paddingTop;
    }
    if (props.paddingBottom) {
      height += props.paddingBottom;
    }
    return height;
  }
}
export default RecordView;
